module.exports = __webpack_public_path__ + "media/images/stripe_white-3686f950b9f0a02b872e0ce5a0b5e099.png";